import { effects } from 'redux-saga'

import callWithHmac from 'internal-components/src/redux/sagas/effects/callWithHmac'
import handleViolations from 'internal-components/src/redux/sagas/effects/handleViolations'
import { receiveSignup } from 'internal-components/src/redux/modules/signup/actions'
import {
  addErrors,
  beginWork,
  clearErrors,
  editSignup,
  endWork,
} from '../../modules/signupEdit/actions'

export default function* submitMsp({ invocation }, signup) {
  try {
    yield effects.put.resolve(beginWork())
    yield effects.put.resolve(clearErrors())

    const result = yield effects.call(
      callWithHmac,
      invocation.signupCreateMsp,
      signup.get('offer'),
      {
        abn: signup.get('abn'),
        address: signup.get('address'),
        addressLocId: signup.get('addressLocId'),
        billingGroupId: signup.get('billingGroupId'),
        preferredAppointmentDate: signup.get('preferredAppointmentDate')
          ? signup.get('preferredAppointmentDate').format('YYYY-MM-DD')
          : null,
        preferredAppointmentTime: signup.get('preferredAppointmentTime'),
        siteContactFirstName: signup.get('siteContactFirstName'),
        siteContactLastName: signup.get('siteContactLastName'),
        siteContactNumber: signup.get('siteContactNumber'),
        clientId: signup.get('clientId'),
        companyName: signup.get('companyName'),
        companySize: signup.get('companySize'),
        contact: signup.get('contact'),
        email: signup.get('email'),
        emailConfirm: signup.get('emailConfirm'),
        extraOffer: signup.get('extraOffer'),
        firstName: signup.get('firstName'),
        lastName: signup.get('lastName'),
        partner: signup.get('partner'),
        servicePassword: signup.get('servicePassword'),
        data: signup.get('data').toObject(),
        user: signup.user,
      },
      signup.get('agreeTerms'),
    )

    yield effects.put.resolve(receiveSignup(result.signup))
    yield effects.put.resolve(editSignup(result.signup.id))

    return true
  } catch (e) {
    yield effects.call(handleViolations, e, addErrors)
  } finally {
    yield effects.put.resolve(endWork())
  }

  return false
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/submitMsp.js